const addFeatureToggleClasses = (el, classes) => {
  if (typeof el !== "object") {
    throw new TypeError("Expected first argument to be an Object");
  }
  if (typeof classes !== "object") {
    throw new TypeError("Expected second argument to be an Object");
  }
  Object.keys(classes)
    .map(key => ({ key, toggle: classes[key] === "true" }))
    .forEach(({ key, toggle }) =>
      el.classList.toggle(`plp-feature-toggle__${key}`, toggle)
    );
};

export default addFeatureToggleClasses;
